// extracted by css-extract-rspack-plugin
export default {"fieldset":"QhrV0","srOnly":"BjzJ1"};